const Seller = ({ children }) => {
  return (
    <div className="pl-[28px] pr-[28px] w-full ">
      {children}
    </div>
  );
};

export default Seller;
